import { OUTREACH_MAX_PAGE_SIZE, useCampaignPageSizeParam } from '../../useCampaignPageSizeParam';
import { useCampaignPageParam } from '../../useCampaignPageParam';

/** What every Creators list takes: the URL-owned search it queries with, and a way to clear it from its empty state. */
export interface CrmCreatorsListProps {
  campaignId: string;
  query: string;
  onClearSearch: () => void;
}

/** The URL-owned page and page size every CRM list pages with, capped at Go's 100-row limit. */
export function useCrmListPaging() {
  const [page, setPage] = useCampaignPageParam();
  const [pageSize, setPageSize] = useCampaignPageSizeParam(OUTREACH_MAX_PAGE_SIZE);
  return { page, setPage, pageSize, setPageSize };
}

export type CrmListPaging = ReturnType<typeof useCrmListPaging>;
